import { Link } from "react-router";

import imagePlaceholder from "../../assets/images/image-placeholder.png";

import styles from "./ContainerObjectList.module.scss";

const ContainerObjectList = ({ objects = [], fromSearch = "" }) => {
  if (!objects.length) {
    return <p className={styles.containerEmpty}>No artworks found.</p>;
  }

  return (
    <ul className={styles.containerItems}>
      {objects.map((item) => (
        <li key={item.objectId}>
          <Link
            className={styles.containerItemLink}
            to={`/art-warehouse/${item.objectId}`}
            state={{ object: item, fromSearch }}
          >
            <div className={styles.containerItemInner}>
              <div className={styles.containerItemBody}>
                <div className={styles.containerDetails}>
                  <div className={styles.containerCell}>
                    <span className={styles.containerLabel}>Title</span>
                    <span className={styles.containerValue}>
                      {item.artworkTitle || item.containerTitle || "-"}
                    </span>
                  </div>
                  <div className={styles.containerCell}>
                    <span className={styles.containerLabel}>Artist</span>
                    <span className={styles.containerValue}>
                      {item.artist || "-"}
                    </span>
                  </div>
                  <div className={styles.containerCell}>
                    <span className={styles.containerLabel}>Type of art</span>
                    <span className={styles.containerValue}>
                      {item.typeOfArt || "-"}
                    </span>
                  </div>
                  <div className={styles.containerCell}>
                  <span className={styles.containerLabel}>Serial</span>
                  <span className={styles.containerValue}>
                    {item.serialNumber || item.objectId || "-"}
                  </span>
                  </div>
                </div>
                <div className={styles.containerImageCol}>
                  <img
                    className={styles.containerItemImage}
                    src={item.imageUrls?.[0] || imagePlaceholder}
                    alt={
                      item.artworkTitle || item.objectId || "Container object"
                    }
                  />
                </div>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default ContainerObjectList;
